
export default function Demerits() {
  const demerits = [
    {
      icon: 'ri-money-yen-circle-line',
      title: '年会費が有料（条件付き無料）',
      description: '年会費は1,375円（税込）と有料です。ただし、スピード発番で申し込めば初年度無料、さらに年間のご利用金額によっては翌年度も無料になります。年会費無料のカードと比較すると、維持コストがかかる点は注意が必要です。',
      solution: 'スピード発番で申込＆年間利用で実質無料に！',
    },
    {
      icon: 'ri-percent-line',
      title: '通常還元率は0.5%と平均的',
      description: '通常のポイント還元率は0.5%（1,000円で1ポイント＝5円相当）と、高還元率カード（1%〜）と比べると低めです。ただし、カード会社優待店舗では最大20倍になるので、対象店舗を積極的に利用することで還元率を上げられます。',
      solution: 'スターバックスやAmazonなど優待店を活用しよう！',
    },
    {
      icon: 'ri-bank-card-line',
      title: '国際ブランドは1種類のみ',
      description: 'このカードは1つの国際ブランドのみの発行となります。海外では一部地域で加盟店が少ない場合もあるため、海外旅行が多い方は別のカードとの併用がおすすめです。',
      solution: '国内利用がメインなら問題なし。海外用にサブカードを持つのも◎',
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#003366] mb-3 text-center">
          地方銀行系スピード発行カードのデメリット
        </h2>
        <p className="text-gray-600 text-center mb-12">正直に伝える注意点と対策方法</p>

        <div className="space-y-6">
          {demerits.map((demerit, index) => (
            <div key={index} className="bg-[#FFF8F8] rounded-xl shadow-md p-6 md:p-8 border border-[#FFE0E0]">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B6B] rounded-full flex-shrink-0">
                  <i className={`${demerit.icon} text-white text-xl`}></i>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-3 flex-wrap">
                    <span className="bg-[#FF6B6B] text-white text-xs font-bold px-3 py-1 rounded-full">
                      デメリット{index + 1}
                    </span>
                    <h3 className="text-lg md:text-xl font-bold text-[#003366]">{demerit.title}</h3>
                  </div>
                  <p className="text-gray-700 text-sm md:text-base leading-relaxed mb-3">
                    {demerit.description}
                  </p>
                  <div className="bg-white border-l-4 border-[#4CAF50] px-4 py-2 rounded">
                    <p className="text-[#003366] text-xs md:text-sm font-medium">
                      <i className="ri-lightbulb-line mr-1 text-[#4CAF50]"></i>
                      <strong>対策：</strong>{demerit.solution}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-[#E8F5E9] rounded-xl p-6 text-center">
          <p className="text-gray-700 text-sm md:text-base">
            <strong className="text-[#003366]">総評：</strong>
            デメリットはあるものの、最短5分のスピード発行と充実した付帯保険を考えると、
            <strong className="text-[#00A651]">急ぎでカードが必要な方や保険重視の方におすすめ</strong>できるカードです。
          </p>
        </div>
      </div>
    </section>
  );
}
